module.exports = __webpack_public_path__ + "img/up.54dbf5b.png";